export { default } from "./slider";
